"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DisLikeIcon = function DisLikeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.40501 10.5449L1.27767 11.1041C1.27767 11.8196 1.85234 12.4046 2.55501 12.4046L9.03367 12.4046L7.85834 16.8789L7.85834 16.9046C7.74301 17.3341 7.84501 17.8149 8.19034 18.1531L13.301 12.9376C13.7743 12.4696 14.055 11.819 14.055 11.1041L14.055 5.9015C14.055 4.47114 12.905 3.3005 11.4997 3.3005L6.38834 3.3005C5.36634 3.3005 4.47167 3.91186 4.07567 4.78293L4.08901 4.78293L1.40501 10.5449ZM6.38834 2L11.4997 2C13.621 2 15.333 3.74279 15.333 5.90214L15.333 11.1041C15.333 12.1835 14.8983 13.1587 14.2083 13.8614L8.19034 20L7.28301 19.0769C6.60567 18.3871 6.38834 17.399 6.63167 16.5144L7.37234 13.7051L2.55501 13.7051C1.14967 13.7051 -0.000324902 12.5351 -0.000325027 11.1041C-0.000325066 10.6619 0.101675 10.2459 0.293008 9.88143L2.86167 4.37986C3.43701 2.98872 4.80434 2 6.38834 2Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.5714L14 3.28573C14 2.3343 14.4447 2.00001 15.3333 2.00001L17.9987 2.00001C19 2.00001 20 2.68466 20 3.92858L20 11.5419C20 12.5557 19.4973 13.5714 18.0033 13.5714L14 13.5714ZM15.3333 12.3532L18.0033 12.3532C18.6667 12.3532 18.6667 11.9424 18.6667 11.5317L18.6667 3.8688C18.6667 3.43166 18.3347 3.21823 18.0033 3.21823L15.3333 3.21823L15.3333 12.3532Z",
    fill: color
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: size,
    height: size,
    fill: "white",
    transform: "translate(20 20) rotate(180)"
  }))));
};

var _default = DisLikeIcon;
exports.default = _default;